import VueCookie from "vue-cookie";
import axios from "axios";

const COOKIE_FIELD_VALUE_STRING = "value=";

const GAInterceptors = function(config) {
  let token = "";
  token = getTokenFromCookie();

  config.headers.common["X-FERCAM-GLOBAL-AUTH"] = token;
  return config;
};

let isAlreadyFetchingAccessToken = false;
var GAInterceptorsOnError = function(error) {
  const {
    config,
    response: { status }
  } = error;

  const originalRequest = config;

  if (status === 401) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;
      var token = getTokenFromCookie();

      fetch(
        process.env.VUE_APP_GLOBALAUTH_API + "Login/RefreshToken/" + token
        
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(newToken) {
          if (newToken) {
            refreshToken(newToken);
            onRrefreshed(newToken);
          }
        })
        .catch(function() {});
    }

    const retryOriginalRequest = new Promise(resolve => {
      subscribeTokenRefresh(token => {
        originalRequest.headers["X-FERCAM-GLOBAL-AUTH"] = token;
        resolve(axios(originalRequest));
      });
    });
    return retryOriginalRequest;
  } else {
    return Promise.reject(error);
  }
};

var getTokenFromCookie = function() {
  const cookieValue = VueCookie.get("GlobalAuthUser");

  if (cookieValue) {
    var token = cookieValue
      .split("&")
      .find(s => s.indexOf(COOKIE_FIELD_VALUE_STRING) > -1)
      .replace(COOKIE_FIELD_VALUE_STRING, "");
    return token;
  } else {
    return "";
  }
};

var refreshToken = function(token) {
  const cookieValue = VueCookie.get("GlobalAuthUser");

  var GACookie = cookieValue.split("&");
  if (GACookie) {
    GACookie[0] = COOKIE_FIELD_VALUE_STRING + token;

    var now = new Date();
    var time = now.getTime();
    // 180 days
    var expireTime = time + 1000*86400*180;
    now.setTime(expireTime);
    
    const newCookie = GACookie.join('&');

    var currentDomain = window.location.hostname.split('.').reverse().slice(0,2).reverse().join(".");

    document.cookie = `GlobalAuthUser=${newCookie};domain=${currentDomain};expires=${now.toUTCString()};path=/`;
  }
};

let refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
  refreshSubscribers.map(cb => cb(token));
}

export default { GAInterceptors, GAInterceptorsOnError };
